import { makeStyles } from '@material-ui/core/styles';
import { rgba } from 'polished';
import styled from 'styled-components';

const useStyles = makeStyles({
  formControl: {
    width: '100%',
    height: '0px',
    maxWidth: '400px',
    position: 'relative',
    top: 80,
    left: 0,
    right: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      width: '90%',
    },
  },
  outilneInput: (props) => ({
    fontFamily: props?.fontFamily === '' ? props.fontFamily : 'inherit',
    background: '#ffffff',
    height: '40px',
    width: '100%',
    '&:hover': {
      border: '1px solid #d7dce0',
    },
  }),
});

export default useStyles;

export const SearchButton = styled.button`
  width: 39px;
  height: 38px;
  background: ${(props) =>
    props.buttonColor ? props.buttonColor : 'var(--color-blue-primary)'};
  border: none;
  border-radius: 4px;
  margin-left: -40px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${(props) => props.iconColor || '#ffffff'};
  :hover {
    background: ${(props) =>
      props.buttonColor
        ? rgba(props.buttonColor, 0.7)
        : 'var(--color-blue-50)'};
  }
`;
